<template>
    <div class="row">
        <div class="col-md-12 mb-1">
            <label class="form-label">İsim</label>
            <input type="text" class="form-control" placeholder="İsim" v-model="value.ParentFirmName" />
        </div>
        <div class="col-md-12">
            <label class="form-label">Kısa İsim</label>
            <input type="text" class="form-control" placeholder="Kısa İsim" v-model="value.ParentFirmShortName" />
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>